export const public_URL = "https://react-svw.onrender.com" || "http://localhost:3001";

export const resources_url = "https://drive.google.com/drive/folders/1l5phebJqYkijUTqHN43GukUNZ9zgIiLX?usp=sharing";
